import { ContactButton } from "@/components/common/contact-button";
import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { popModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

interface CompareFailedModalProps {
  title?: string;
  description?: string;
  /** 같은 파일을 다시 올려 같은 실패를 반복하지 않도록 문의 경로를 함께 둔다. */
  showContact?: boolean;
}

export const CompareFailedModal = ({
  title = "비교에 실패했습니다.",
  description = "잠시 후 다시 시도해주세요.",
  showContact = false,
}: CompareFailedModalProps) => {
  return (
    <ModalWrapper className="flex w-[512px] max-w-lg flex-col items-end gap-4 rounded-[10px] border border-line-normal bg-background-base p-6 shadow-lg">
      <div className="flex flex-col gap-2 self-stretch">
        <h2 className="headline-1-semibold text-label-normal">{title}</h2>
        <p className="body-1-normal-medium leading-relaxed text-label-alternative break-keep">
          {description}
        </p>
      </div>
      <div className="flex items-center justify-end gap-2 self-stretch">
        {showContact && (
          <ContactButton text="문의하기" className="text-label-alternative" />
        )}
        <Button
          variant="solid"
          color="primary"
          size="base"
          className="min-w-[80px]"
          onClick={() => popModal()}
        >
          확인
        </Button>
      </div>
    </ModalWrapper>
  );
};
